var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between"},[_c('h1',{staticClass:"page-header"},[_vm._v(_vm._s(_vm.$t('cardToBePrint.pageTitle')))]),_c('ts-breadcrumb',{attrs:{"items":[
        { text: _vm.$t('toHomePage'), href: '/' },
        {
          text: _vm.$t('cardToBePrint.pageTitle'),
          active: true
        }
      ]}})],1),_c('ts-card',[_c('ts-tabs',{attrs:{"target":"cardToBePrintList"}},[_c('ts-tab',[_vm._v(_vm._s(_vm.$t('cardToBePrint.newProfile')))]),_c('ts-tab',[_vm._v(_vm._s(_vm.$t('cardToBePrint.existingProfile')))]),_c('ts-tab',[_vm._v(_vm._s(_vm.$t('cardToBePrint.allProfile')))])],1),_c('ts-tab-panes',{attrs:{"name":"cardToBePrintList"}},[_c('ts-tab-pane',[_c('new-profile')],1),_c('ts-tab-pane',[_c('existing-profile')],1),_c('ts-tab-pane',[_c('all-profile')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }